import React from 'react';
import styles from 'src/app/components/ETECubeSection/ETECubeSection.module.scss';
import { OntologyAndFlowOptionType } from '../ETECubeSection/etecube-section.config';
import { useTranslation } from 'react-i18next';

import Form from 'antd/es/form';
import Select from 'antd/es/select';
import Radio from 'antd/es/radio';
import Collapse from 'antd/es/collapse';

type EventOption = {
  id: string;
  eventId: string;
};

type Props = {
  dbType: string;
  setDbType: (val: 'new' | 'replicate') => void;
  flowOption: OntologyAndFlowOptionType;
  setFlowOption: (val: OntologyAndFlowOptionType) => void;
  ontologyOption: OntologyAndFlowOptionType;
  setOntologyOption: (val: OntologyAndFlowOptionType) => void;
  allEvent: EventOption[];
  onFormChange: (key: string, val: any) => void;
  inEventForm?: boolean;
};

const AdvancedDatabaseOptions: React.FC<Props> = ({
  dbType,
  setDbType,
  flowOption,
  setFlowOption,
  ontologyOption,
  setOntologyOption,
  allEvent,
  onFormChange,
  inEventForm = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className={`${styles.inputContainer} ${inEventForm ? styles.eventFormFontSize : ''}`}>
      <Collapse>
        <Collapse.Panel header={t('administration.event.advancedOptions')} key="1">
          <Form.Item name="dbType">
            <div>{t('general.databaseType')}</div>
            <Radio.Group defaultValue={dbType} value={dbType} onChange={(e) => setDbType(e.target.value)}>
              <Radio value="new">{t('administration.event.newDatabase')}</Radio>
              <Radio value="replicate">{t('administration.event.replicateDatabase')}</Radio>
            </Radio.Group>
          </Form.Item>

          {dbType === 'new' && (
            <>
              <Form.Item name="flowOption">
                <div>{t('administration.event.flowOption')}</div>
                <Radio.Group
                  defaultValue={flowOption}
                  value={flowOption}
                  onChange={(e) => setFlowOption(e.target.value)}
                >
                  <Radio value={OntologyAndFlowOptionType.DEFAULT}>{t('administration.event.default')}</Radio>
                  <Radio value={OntologyAndFlowOptionType.FROM_EVENT}>
                    {t('administration.event.importFromEvent')}
                  </Radio>
                  <Radio value={OntologyAndFlowOptionType.EMPTY}>{t('general.empty')}</Radio>
                </Radio.Group>
              </Form.Item>

              {flowOption === OntologyAndFlowOptionType.FROM_EVENT && (
                <Form.Item name="importEventId">
                  <span>{t('administration.event.selectDatabaseToImport')}</span>
                  <Select
                    showSearch
                    style={{ width: '100%' }}
                    optionFilterProp="children"
                    onChange={(e) => onFormChange('flowOptionSelectedEventId', e as string)}
                  >
                    {allEvent.map((option) => (
                      <Select.Option key={option.id} value={option.id}>
                        {option.eventId}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
              <Form.Item name="ontologyOption">
                <div>{t('administration.event.ontologyOption')}</div>
                <Radio.Group
                  defaultValue={ontologyOption}
                  value={ontologyOption}
                  onChange={(e) => setOntologyOption(e.target.value)}
                >
                  <Radio value={OntologyAndFlowOptionType.DEFAULT}>{t('administration.event.default')}</Radio>
                  <Radio value={OntologyAndFlowOptionType.FROM_EVENT}>
                    {t('administration.event.importFromEvent')}
                  </Radio>
                  <Radio value={OntologyAndFlowOptionType.EMPTY}>{t('general.empty')}</Radio>
                </Radio.Group>
              </Form.Item>

              {ontologyOption === OntologyAndFlowOptionType.FROM_EVENT && (
                <Form.Item name="importEventId">
                  <span>{t('administration.event.selectDatabaseToImport')}</span>
                  <Select
                    showSearch
                    style={{ width: '100%' }}
                    optionFilterProp="children"
                    onChange={(e) => onFormChange('ontologyOptionSelectedEventId', e as string)}
                  >
                    {allEvent.map((option) => (
                      <Select.Option key={option.id} value={option.id}>
                        {option.eventId}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
            </>
          )}

          {dbType === 'replicate' && (
            <Form.Item name="selectedEventId">
              <span>{t('administration.event.selectDatabaseToReplicate')}</span>
              <Select
                showSearch
                style={{ width: '100%' }}
                optionFilterProp="children"
                onChange={(e) => onFormChange('replicateEventId', e as string)}
              >
                {allEvent.map((option) => (
                  <Select.Option key={option.id} value={option.id}>
                    {option.eventId}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          )}
        </Collapse.Panel>
      </Collapse>
    </div>
  );
};

export default AdvancedDatabaseOptions;
